import { render } from "./AdminPackageCreate.vue?vue&type=template&id=ed9c3ae0&scoped=true&ts=true&lang=true"
import script from "./AdminPackageCreate.vue?vue&type=script&lang=ts"
export * from "./AdminPackageCreate.vue?vue&type=script&lang=ts"

import "./AdminPackageCreate.vue?vue&type=style&index=0&id=ed9c3ae0&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9c3ae0"]])

export default __exports__